export default __webpack_public_path__ + "static/media/paralax_text.8ac22046.png";